import classNames from 'classnames';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { Modal } from '../../molecules';
import { WrapTextNodes } from '../../utils/WrapTextNodes';
import { FadeTransition } from './FadeTransition';
import styles from './SlideOutPanel.module.scss';
import { SlideOutPanelProps } from './SlideOutPanel.types';

const SlideOutPanel = (props: SlideOutPanelProps) => {
  const {
    className,
    children,
    direction = 'Right',
    size = 'Medium',
    // Modal props
    backdrop,
    disableBackdropDismiss,
    onHide,
    renderBackdrop,
    show,
  } = props;

  const variantProps = useBuildVariantProps(
    'slide-out-panel',
    { size, direction },
  );

  return (
    <Modal
      className={classNames(
        styles.slideOutPanel,
        styles[`slideOutPanel--${size.toLowerCase()}`],
        styles[`slideOutPanel--${direction?.toLowerCase()}`],
        className,
      )}
      backdrop={backdrop}
      disableBackdropDismiss={disableBackdropDismiss}
      onHide={onHide}
      renderBackdrop={renderBackdrop}
      show={show}
      Transition={FadeTransition}
      {...variantProps}
    >
      {children && <WrapTextNodes>{children}</WrapTextNodes>}
    </Modal>
  )
};

export default SlideOutPanel